"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconDocument = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M47.29 28.1H22.13a1.28 1.28 0 0 0 0 2.56h25.16a1.28 1.28 0 0 0 0-2.56zM47.29 45.86H22.13a1.28 1.28 0 0 0 0 2.56h25.16a1.28 1.28 0 0 0 0-2.56zM22.13 22h20.76a1.28 1.28 0 1 0 0-2.56H22.13a1.28 1.28 0 0 0 0 2.56zM47.29 37.05H22.13a1.28 1.28 0 0 0 0 2.56h25.16a1.28 1.28 0 0 0 0-2.56z"
  }), _react["default"].createElement("path", {
    d: "M55 59.3V10.87a3 3 0 0 0-3-3H17.95a3 3 0 0 0-3 3v48.26a3 3 0 0 0 3 3H53a3 3 0 0 0 2-2.83zm-3 .25H17.95a.43.43 0 0 1-.43-.42V10.87a.43.43 0 0 1 .43-.43h34.1a.43.43 0 0 1 .42.43v48.26a.43.43 0 0 1-.42.42z"
  })),
  height: undefined,
  width: undefined
});
IconDocument.displayName = 'IconDocument';
var _default = IconDocument;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/document.js
// module id = 155
// module chunks = 0